var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderBackground5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "File KhungVien") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M584.61,832.89H10.67V9H584.61Zm-570.9-3H581.57V12H13.71Zm562.92-4.37h-558V16.41h558Zm-557-1h556v-807h-556Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderBackground5);
export default __webpack_public_path__ + "static/media/borderBackground5.044104d520d1f956f788fe17d0471e2c.svg";
export { ForwardRef as ReactComponent };